<div class="pdf-viewer-container">
  @if (exportSpinner) {
    <div class="spinner-row">
      <div class="table-spinner">
        <app-nada-spinner />
      </div>
    </div>
  } @else {
    <!-- Iframe for PDF -->
    <iframe class="pdf-frame" [attr.src]="pdfSrc" class="pdf-frame"></iframe>
  }

  <!-- Buttons Container -->
  <div class="action-buttons">
    <div>
      <button class="btn-close-export" (click)="downloadPDF()">Print</button>
    </div>
    <div>
      <button class="btn-close-cls" (click)="closeViewer()">Close</button>
    </div>
  </div>
</div>
